import React, { useEffect } from "react";
import Card from "./Card";
import CircularProgress from "@mui/material/CircularProgress";
import { useState, createRef } from "react";

const ListItem = ({ places, load, childClick, width }) => {
  const [elRefs, setElRefs] = useState([]);

  useEffect(() => {
    const refs = Array(places?.length)
      .fill()
      .map((_, i) => createRef());
    setElRefs(refs);
  }, [places]);

  return (
    <>
      {!load &&
        places?.map((place, i) => {
          return (
            <div key={i} ref={elRefs[i]}>
              <Card
                place={place}
                selected={Number(childClick) === i}
                refProp={elRefs[i]}
                width = {width}
              />
            </div>
          );
        })}

    </>
  );
};

export default ListItem;
